import React from 'react'
import type { Props as DropZoneProps } from './DropZone'
import DropZone from './DropZone'
import { UploaderBox, Text, Upload } from './styles'
type Props = {
  disabled?: boolean
  disabledText?: string
  bottomMargin?: string
} & DropZoneProps
export const UploadContent = (props: Props) => {
  const { disabled, disabledText, bottomMargin } = props
  return (
    <UploaderBox data-type='uploader-box'>
      {disabled && disabledText ? (
        <Text data-type='text'>{disabledText}</Text>
      ) : (
        <>
          <Text data-type='text' hideOnMobile>Drag and Drop image files here</Text>
          <Text data-type='text' hideOnMobile>OR</Text>
          <Upload mb={bottomMargin || 0} data-type='cta-text'>CLICK HERE TO UPLOAD</Upload>
        </>
      )}
    </UploaderBox>
  )
}
export const Uploader = (props: Props) => (
  <DropZone {...props}>
    <UploadContent {...props} />
  </DropZone>
)
export { DropZone }